import { Role, ADMIN_ROLES } from "@/shared/types/role";
import type { UserStatusFilter } from "./types";

export const DISPLAY_NAME_MIN_LENGTH = 1;
/** Matches the backend `CreateUserInput.displayName` maxLength. */
export const DISPLAY_NAME_MAX_LENGTH = 200;
export const EMAIL_MAX_LENGTH = 254;

/**
 * Roles a Super Admin can assign when creating a user through the
 * backoffice. Scoped to internal WanderFit staff — owner/guest accounts
 * onboard via the mobile app or the invitation flow. The backend
 * contract accepts the full `Role` enum, so this restriction is UI-only
 * and can be broadened in one place when product needs it.
 */
export const CREATABLE_ROLES: readonly Role[] = [...ADMIN_ROLES];

export const USERS_LIST_QUERY_KEY = ["admin", "users"] as const;
export const USER_DETAIL_QUERY_KEY = ["admin", "users", "detail"] as const;
export { USER_MEMBERSHIPS_QUERY_KEY } from "@/shared/organizations/use-user-memberships";

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;
export const SEARCH_DEBOUNCE_MS = 300;

export const USER_STATUS_FILTERS: readonly UserStatusFilter[] = ["all", "active", "deactivated"];

/**
 * Roles selectable in the search filter and in the change-role dialog.
 * Order is curated for the UI: admin roles first, then property side,
 * then venue side, then guest. Mirrors the order users will most often
 * scan in a long dropdown.
 */
export const ROLE_FILTER_ORDER: readonly Role[] = [
  ...ADMIN_ROLES,
  Role.PROPERTY_OWNER,
  Role.PROPERTY_MANAGER,
  Role.VENUE_OWNER,
  Role.VENUE_EMPLOYEE,
  Role.GUEST,
];
